

import { Component, Mixins } from 'vue-property-decorator';
import DumpPopupMixin from '~/mixins/dumpPopup.mixin';
import { DevicesModule } from '~/store/modules/devices';
import PopupMixin from '~common-mixins/PopupMixin';

@Component
export default class OperationModelDumpPopup extends Mixins(PopupMixin, DumpPopupMixin) {
    filePrefix = 'diagnosis';

    get rawDumpValue() {
        return DevicesModule.diagnosisValue;
    }

    async diagnosis() {
        try {
            const data = await DevicesModule.currentGateway?.getDiagnosis() as string;
            await DevicesModule.setDiagnosisValue(data);
        } catch (error) {
            await DevicesModule.setDiagnosisValue('Error while fetching dump');
        }
    }
}
